import {Injectable} from '@angular/core';
import {DataService} from 'core/data-services/data-service';
import {URLHelper} from 'helpers/url.helper';
import {HttpHeaders} from '@angular/common/http';

@Injectable()
export class SubscriptionDataService extends DataService {

  getParkingSubscribers(options: any, searchFilter: string, searchCategory?: any): Promise<any> {
    options = options || {};
    options.query = options.query || {};
    options.query['query'] = URLHelper.buildGeneralSearchFilter(
      {
        'name': 'string',
        'email': 'string',
        'phoneNumber': 'string',
        'licensePlateLetter': 'string',
        'licensePlateNumber': 'string',
        'licensePlateProvince': 'string',
        'remark': 'string'
      },
      searchFilter || '*');
    let url = URLHelper.buildQueryString('/subscriptions?', options.query, '');
    if (searchCategory) { url = url + `;(status==${searchCategory})`; }
    return this.get('payments/', {'parking-lots': 'PARKING_LOT_ID'}, url + '&sort=createdDate,desc');
  }

  createSubscriptions(subscriberBody: any, packageId: any): Promise<any> {
    const options = {headers: new HttpHeaders().set('Content-Type', 'application/json')};
    return this.post('payments/', {'parking-lots': 'PARKING_LOT_ID'}, `/subscriptions?packageId=${packageId}`, subscriberBody, options);
  }

  cancelLatestSubscription(id): Promise<any> {
    return this.delete('payments/', {'parking-lots': 'PARKING_LOT_ID'}, `/subscriptions/${id}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/data-services/parking/subscription.service.ts